import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  languageChanged: ['lang'],
});

export const AppTypes = Types;
export default Creators;



// WEBPACK FOOTER //
// ./src/state/actions/AppActions.js